import { capitalizeAllIfLower } from '@btime/helpers'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  useOpenChecklistModal,
  useOpenPlaceModal,
  useOpenUserModal
} from '../../../../../utils/routes/modals/modalsActions'
import { useRanking } from './_load/RankingLoader'
import { useWidget } from '../../WidgetWrapper'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../../packages/kiti/components/actions/Link'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const useOpenModal = () => {
  const widget = useWidget()
  const openUser = useOpenUserModal()
  const openPlace = useOpenPlaceModal()
  const openChecklist = useOpenChecklistModal()

  switch (widget.data?.perspective) {
    case 'user':
      return openUser
    case 'place':
      return openPlace
    case 'checklist':
      return openChecklist
    default:
      return () => {}
  }
}

const RankingTable = () => {
  const { t } = useTranslation('common')
  const data = useRanking()
  const openDetailsModal = useOpenModal()

  const columns = [
    {
      label: t('widgets.name'),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 3,
      render: (value, record) => (
        <Link onClick={() => openDetailsModal({ ...record, id: record.recordId })} block>
          <Text bold color="dark2" breakWord>
            {capitalizeAllIfLower(value)}
          </Text>
        </Link>
      )
    },

    {
      label: t('widgets.completed'),
      dataIndex: 'completedCount',
      sortIndex: 'COMPLETED_COUNT',
      flex: 1,
      render: value => (
        <Text bold color="darkGreen">
          {value}
        </Text>
      )
    },

    {
      label: t('widgets.open'),
      dataIndex: 'openCount',
      sortIndex: 'OPEN_COUNT',
      flex: 1,
      render: value => (
        <Text bold color="dark3">
          {value}
        </Text>
      )
    },

    {
      label: t('widgets.pending'),
      dataIndex: 'pendingCount',
      sortIndex: 'PENDING_COUNT',
      flex: 1,
      render: value => (
        <Text bold color="orange">
          {value}
        </Text>
      )
    }

    // {
    // label: 'Tempo médio',
    // dataIndex: 'averageTime',
    // sortIndex: 'AVERAGE_TIME',
    // flex: 1,
    // render: value => <Text color="dark3">{formatSeconds(value)}</Text>
    // }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} size="xsmall" />
}

export default RankingTable
